import { ArrowDown, ArrowRight, ArrowUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { TrendMetric } from "@/types/api";

const directionConfig = {
  improving: {
    icon: ArrowDown,
    color: "text-green-400",
    bg: "bg-green-500/10",
    label: "Improving",
  },
  stable: {
    icon: ArrowRight,
    color: "text-yellow-400",
    bg: "bg-yellow-500/10",
    label: "Stable",
  },
  degrading: {
    icon: ArrowUp,
    color: "text-red-400",
    bg: "bg-red-500/10",
    label: "Degrading",
  },
};

const displayNames: Record<string, string> = {
  alert_volume: "Alert Volume",
  mttr: "Mean Time to Respond",
  incidents: "Incidents",
};

interface TrendCardProps {
  metric: TrendMetric;
}

export function TrendCard({ metric }: TrendCardProps) {
  const config = directionConfig[metric.direction];
  const Icon = config.icon;
  const displayName = displayNames[metric.name] ?? metric.name;

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">{displayName}</p>
            <p className="mt-1 text-2xl font-bold tabular-nums">
              {metric.name === "mttr"
                ? `${metric.current.toFixed(1)}h`
                : metric.current.toLocaleString()}
            </p>
          </div>
          <div className={cn("flex items-center gap-1 rounded-full px-2 py-1", config.bg)}>
            <Icon className={cn("h-3.5 w-3.5", config.color)} />
            <span className={cn("text-xs font-medium", config.color)}>
              {metric.change_pct !== null
                ? `${metric.change_pct > 0 ? "+" : ""}${metric.change_pct.toFixed(0)}%`
                : config.label}
            </span>
          </div>
        </div>
        <div className="mt-2 flex items-center gap-2 text-xs text-muted-foreground">
          <span>Previous: {metric.name === "mttr"
            ? `${metric.previous.toFixed(1)}h`
            : metric.previous.toLocaleString()}</span>
        </div>
      </CardContent>
    </Card>
  );
}
